{
  "customer-form-dialog": {
    "field": {
      "last_checkin": "Letzter Checkin",
      "number_of_visit": "Anzahl der Besuche",
      "registered_since": "Registriert seit",
      "type": "Typ"
    },
    "button": {
      "cancel": "Abbrechen",
      "submit": "Einreichen"
    },
    "text": {
      "create_customer": "Neues Kundenprofil erstellen",
      "create_customer_success": "Erfolgreich erstellt",
      "edit_customer": "Kundenprofil bearbeiten",
      "edit_customer_success": "Erfolgreich aktualisiert"
    }
  }
}
